import { IoCallOutline } from "react-icons/io5";
import { AppContext } from "../../context/AppContext";
import { useContext } from "react";
import "./index.css";

const RequestCallButton = () => {
  const { setModalShow } = useContext(AppContext);
  return (
    <div className="call-req-btn-cont text-center">
      <button
        className="section-call-req-button "
        onClick={() => setModalShow(true)}
      >
        <IoCallOutline className="phone-icon" /> Book Free Career Counselling
      </button>
    </div>
  );
};

export default RequestCallButton;
